import PropTypes from 'prop-types';
import React from 'react';
import { LOOKUP_ADDRESS_AUTOCOMPLETE } from '../../brands/default/content/components/address';
import Input from '../_generic/input/Input';

const LookupAddressAutocomplete = ({
  onChangeFunction,
  values,
  extraClasses = '',
  disabled = false,
}) => {
  return (
    <>
      <div className="col-12">
        <Input
          autoCapitalize="off"
          autoComplete="off"
          autoCorrect="off"
          dataqa="autocomplete"
          disabled={disabled}
          extraClasses={extraClasses}
          inputValue={values.autocomplete}
          name={'autocomplete'}
          onChangeFunction={onChangeFunction}
          placeholder={LOOKUP_ADDRESS_AUTOCOMPLETE.prompt}
          required={false}
          type="text"
          value={values.autocomplete}
        />
      </div>
    </>
  );
};

LookupAddressAutocomplete.propTypes = {
  disabled: PropTypes.bool,
  extraClasses: PropTypes.string,
  onChangeFunction: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

export default LookupAddressAutocomplete;
